import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export const AskEntry = ({ testid = "ask-entry" }) => (
  <Link to="/conecta/cruce" data-testid={testid}
    className="flex items-center gap-3 px-4 py-3.5 rounded-2xl bg-[#0b2a47] text-white active:scale-[0.99] transition-transform">
    <Sparkles className="w-5 h-5 text-[#bc9538] shrink-0" />
    <div className="flex-1 min-w-0">
      <p className="font-heading font-bold leading-tight">Dame una opción</p>
      <p className="text-xs text-white/70 truncate">"Necesito alguien que haga avalúos en Querétaro" · "¿Qué tengo con…?"</p>
    </div>
  </Link>
);
